module.exports = __webpack_public_path__ + "static/media/gloria-win.bde163af.png";